import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../../util/reactIntl';

import FilterPlain from '../FilterPlain/FilterPlain';

import {
  LISTED_PARAM,
  LISTED_OPTIONS,
  normalizeListedToken,
  isListedFilterActive,
  toUrlParams,
  clearUrlParams,
} from './dateListedFilterHelpers';

import css from './DateListedFilter.module.css';

export { LISTED_PARAM } from './dateListedFilterHelpers';

/**
 * Single-select Date listed filter (rolling first-went-live windows).
 */
const DateListedFilter = props => {
  const intl = useIntl();
  const {
    className,
    rootClassName,
    id,
    containerId,
    urlQueryParams = {},
    onSubmit,
    getAriaLabel,
  } = props;

  const selectedToken = normalizeListedToken(urlQueryParams[LISTED_PARAM]);
  const isSelected = isListedFilterActive(urlQueryParams[LISTED_PARAM]);
  const label = intl.formatMessage({ id: 'DateListedFilter.label' });
  const selectedOption = LISTED_OPTIONS.find(o => o.token === selectedToken) || LISTED_OPTIONS[0];
  const hint = intl.formatMessage({ id: selectedOption.hintId });

  const handlePlainSubmit = values => {
    if (values === null) {
      onSubmit(clearUrlParams());
    }
  };

  const handleChipSelect = token => {
    onSubmit(toUrlParams(token));
  };

  const onChipKeyDown = (event, index) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
      return;
    }
    event.preventDefault();
    const delta = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (index + delta + LISTED_OPTIONS.length) % LISTED_OPTIONS.length;
    const nextButton = document.getElementById(`${id}-chip-${LISTED_OPTIONS[nextIndex].token}`);
    nextButton?.focus();
  };

  return (
    <FilterPlain
      className={className}
      rootClassName={rootClassName}
      label={label}
      ariaLabel={getAriaLabel(label, isSelected ? selectedToken : '')}
      isSelected={isSelected}
      id={`${id}.plain`}
      liveEdit
      onSubmit={handlePlainSubmit}
      initialValues={{ listed: selectedToken }}
      containerId={containerId}
    >
      <fieldset className={css.chipGroup} role="radiogroup" aria-label={label}>
        <legend className={css.accessibilityLegend}>{label}</legend>
        {LISTED_OPTIONS.map((option, index) => {
          const checked = option.token === selectedToken;
          return (
            <button
              key={option.token}
              id={`${id}-chip-${option.token}`}
              type="button"
              role="radio"
              aria-checked={checked}
              className={classNames(css.chip, { [css.chipSelected]: checked })}
              onClick={() => handleChipSelect(option.token)}
              onKeyDown={event => onChipKeyDown(event, index)}
            >
              {intl.formatMessage({ id: option.labelId })}
            </button>
          );
        })}
      </fieldset>
      <p className={css.hint}>{hint}</p>
    </FilterPlain>
  );
};

export default DateListedFilter;
